import { InputMessageConfig } from '@sdpp-web/lib/ui/form';
import { UserFormModel } from './user-form-model';
import {
  ValidatorKeys as NavPortalAdminValidatorKeys,
  Validators as NavPortalAdminValidators
} from '../utils/validators';

export class UserFormValidationModel {
  public readonly validators: Record<keyof UserFormModel, InputMessageConfig>;

  constructor() {
    this.validators = {
      title: InputMessageConfig.make().addRequired('Title is required'),
      firstName: InputMessageConfig.make().addError(
        'FirstName must contain only characters',
        NavPortalAdminValidatorKeys.onlyAlphabets,
        NavPortalAdminValidators.onlyAlphabets
      ),
      lastName: InputMessageConfig.make().addError(
        'LastName must contain only characters',
        NavPortalAdminValidatorKeys.onlyAlphabets,
        NavPortalAdminValidators.onlyAlphabets
      ),
      email: InputMessageConfig.make().addError(
        'Email is invalid',
        NavPortalAdminValidatorKeys.email,
        NavPortalAdminValidators.email
      ),
      phoneNumber: InputMessageConfig.make().addError(
        'Enter valid phone number',
        NavPortalAdminValidatorKeys.phoneNumber,
        NavPortalAdminValidators.phoneNumber
      ),
      emailGroup: InputMessageConfig.make().addError(
        'Enter valid email group',
        NavPortalAdminValidatorKeys.emailGroup,
        NavPortalAdminValidators.emailGroup
      ),
      company: InputMessageConfig.make().addRequired('Company is required')
    };
  }
}
